import Model from './Model'

export default class Settings extends Model {
    resource() {
        return 'settings'
    }
}
